import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTRSCluster } from 'API/TRSCluster/deleteTRSCluster';

const useDeleteTRSCluster = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const deleteCluster = async (clusterId) => {
        try {
            const response = await deleteTRSCluster(clusterId);
            return response.data;
        } catch (error) {
            console.error('Error deleting TRS cluster:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteCluster,
        onSuccess: (data, clusterId) => {
            // Invalidate and refetch the clusters list
            queryClient.invalidateQueries({ queryKey: ['TRSClusters'] });
            // Remove the specific cluster from cache
            queryClient.removeQueries({ queryKey: ['TRSCluster', clusterId] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteTRSCluster;
